import * as React from 'react';
import { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import { AppContext, AppContextType } from '../../AppContextType';
import { Candidate } from '../../Model/Candidate';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { JobVacancy } from '../../Model/JobVacancy';
import { UriBuilder } from '../../Service/UriBuilder';
import { Type } from '../../Type';

interface SidebarItemProps {
    type: Type
    model: JobCenterModelInterface
    isOpen: boolean
    showSelector: boolean
    selected: boolean
}

export class SidebarItem<M extends Candidate | JobVacancy> extends React.Component<SidebarItemProps> {
    public static contextType = AppContextType;
    public context: AppContext<M> = {} as AppContext<M>;

    constructor(props: SidebarItemProps, context: AppContext<M>) {
        super(props, context);
        this.handleClickAdd = this.handleClickAdd.bind(this);
        this.handleClickRemove = this.handleClickRemove.bind(this);
    }

    public render() {
        const props = this.props;
        const className = 'job-center-sidebar-item' + (props.isOpen ? ' -open' : '');
        const model = props.model;
        const uriBuilder = new UriBuilder();
        const location = this.renderLocation(model);

        return <Link to={uriBuilder.uriForModel(model)}
                     className={className}
                     data-department={model.department?.referenceId}>
            {this.renderIndicator(props)}
            <div className="jc-upper">
                <div className="title">{model.title}</div>
            </div>
            <div className="jc-lower">
                <div className="reference-id">REF {model.referenceId}</div>
                {location}
            </div>
            {this.renderSelector(props)}
        </Link>;
    }

    private renderLocation(model: JobCenterModelInterface | JobVacancy) {
        return (model instanceof JobVacancy && model.location)
            ? <div className="location">{model.location}</div>
            : null;
    }

    private renderSelector(props: SidebarItemProps) {
        if (!props.showSelector) {
            return null;
        }
        if (props.selected) {
            return <button className="jc-item-selector -remove -selected" onClick={this.handleClickRemove}>
                <i className="fal fa-check-square"/>
            </button>;
        } else {
            return <button className="jc-item-selector -add" onClick={this.handleClickAdd}>
                <i className="fal fa-square"/>
            </button>;
        }
    }

    private renderIndicator(props: SidebarItemProps) {
        if (props.showSelector && props.selected) {
            return <div className="jc-item-indicator -selected">
                <i className="far fa-check"/>
            </div>;
        } else {
            return null;
        }
    }

    private handleClickAdd(event: SyntheticEvent) {
        event.preventDefault();
        this.context.handler.selectJobVacancy(this.props.model as JobVacancy);
    }

    private handleClickRemove(event: SyntheticEvent) {
        event.preventDefault();
        this.context.handler.unselectJobVacancy(this.props.model as JobVacancy);
    }
}
